import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "onChange", "onOpenChange"];
import { memo, useCallback } from 'react';
import CRMPropertyDateInput from 'customer-data-properties/date/CRMPropertyDateInput';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
import I18n from 'I18n';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useProperty } from '../v2/hooks/useProperty';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';

// Given a UTC timestamp for midnight on some date in the current user's
// timezone, adds the current time-of-day. Returns the given date, adjusted
// to match the current time-of-day
import { jsx as _jsx } from "react/jsx-runtime";
const addCurrentTimeOfDay = value => {
  const startOfDay = I18n.moment.userTz().startOf('day').valueOf();
  const currentTime = I18n.moment.userTz().valueOf();
  const timeOffset = currentTime - startOfDay;
  return I18n.moment.userTz(value).add(timeOffset).valueOf();
};
const PropertyInputCloseCreateDate = _ref => {
  let {
      inputRef,
      onChange,
      onOpenChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useComponentMountMetric('PropertyInputCloseCreateDate');
  const property = useProperty();
  const value = usePropertyValue();
  const handleChange = useCallback(evt => {
    const {
      target: {
        value: newValue
      }
    } = evt;
    if (typeof onChange === 'function') {
      // CRMPropertyDateInput (UIDateInput)'s onChange sends `number | null`; convert to `string | null`
      onChange(newValue == null ? evt : syntheticEvent(String(addCurrentTimeOfDay(newValue))));
    }
  }, [onChange]);
  return /*#__PURE__*/_jsx(CRMPropertyDateInput, Object.assign({}, getTransferrableProps(rest), {
    value: value,
    momentType: MomentTypes.USER,
    onChange: handleChange,
    onOpenChange: onOpenChange,
    inputRef: inputRef,
    type: property.type === DATE ? 'date' : undefined
  }));
};
export default /*#__PURE__*/memo(PropertyInputCloseCreateDate);